var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "netgsm-extension-mapping" } },
    [
      _c("div", { staticClass: "page-header" }, [
        _c("div", { staticClass: "left" }, [
          _c("h3", [_vm._v(_vm._s(_vm.$t("message.netgsmMappingTitle")))]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.$t("message.netgsmMappingSubtitle")))]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "right" },
          [
            _c(
              "a-button",
              {
                attrs: { loading: _vm.loading, icon: "reload" },
                on: { click: _vm.refreshData },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.refresh")) +
                    "\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "a-button",
              {
                attrs: { type: "primary", icon: "plus" },
                on: {
                  click: function ($event) {
                    _vm.showAddModal = true
                  },
                },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.netgsmMappingAddBtn")) +
                    "\n            "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "statistics" }, [
        _c("div", { staticClass: "stats-grid" }, [
          _c("div", { staticClass: "stat-card" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "stat-content" }, [
              _c("div", { staticClass: "stat-value" }, [
                _vm._v(_vm._s(_vm.webSocketExtensions.length)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-label" }, [
                _vm._v(_vm._s(_vm.$t("message.netgsmStatWebSocketExt"))),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "stat-card" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "stat-content" }, [
              _c("div", { staticClass: "stat-value" }, [
                _vm._v(_vm._s(Object.keys(_vm.currentMappings).length)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-label" }, [
                _vm._v(_vm._s(_vm.$t("message.netgsmStatMapped"))),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "stat-card" }, [
            _vm._m(2),
            _vm._v(" "),
            _c("div", { staticClass: "stat-content" }, [
              _c("div", { staticClass: "stat-value" }, [
                _vm._v(_vm._s(_vm.unmappedExtensions.length)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-label" }, [
                _vm._v(_vm._s(_vm.$t("message.netgsmStatUnmapped"))),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("SupsisTable", {
            attrs: {
              columns: _vm.tableColumns,
              rows: _vm.tableRows,
              loading: _vm.loading,
              "bottom-pagination": "",
              "pagination-cursor": _vm.pagination,
              options: {
                fixedHeader: true,
                borderX: true,
                borderY: true,
              },
            },
            on: {
              "cursor-changed": function (cursor) {
                return (_vm.pagination = cursor)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: _vm.$t("message.netgsmMappingModalAddTitle"),
            confirmLoading: _vm.saving,
            width: "700px",
          },
          on: { ok: _vm.handleSaveMapping, cancel: _vm.handleCancelMapping },
          model: {
            value: _vm.showAddModal,
            callback: function ($$v) {
              _vm.showAddModal = $$v
            },
            expression: "showAddModal",
          },
        },
        [
          _c(
            "a-form",
            { attrs: { layout: "vertical", id: "frm-add-mapping" } },
            [
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: _vm.$t("message.netgsmMappingSelectExtension"),
                    required: "",
                  },
                },
                [
                  _c(
                    "a-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: _vm.$t(
                          "message.netgsmMappingExtensionPlaceholder"
                        ),
                        showSearch: "",
                        filterOption: _vm.filterExtension,
                      },
                      model: {
                        value: _vm.selectedExtension,
                        callback: function ($$v) {
                          _vm.selectedExtension = $$v
                        },
                        expression: "selectedExtension",
                      },
                    },
                    _vm._l(_vm.unmappedExtensions, function (extension) {
                      return _c(
                        "a-select-option",
                        {
                          key: extension.extension,
                          attrs: { value: extension.extension },
                        },
                        [
                          _c("div", { staticClass: "extension-option" }, [
                            _c("span", { staticClass: "extension-number" }, [
                              _vm._v(_vm._s(extension.extension)),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "extension-name" }, [
                              _vm._v(_vm._s(extension.displayname)),
                            ]),
                          ]),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: _vm.$t("message.netgsmMappingSelectUser"),
                    required: "",
                  },
                },
                [
                  !_vm.selectedUser
                    ? _c(
                        "div",
                        { staticClass: "user-selection" },
                        [
                          _c(
                            "a-button",
                            {
                              attrs: {
                                type: "dashed",
                                icon: "user",
                                block: "",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.showUserPicker = true
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$t("message.netgsmMappingSelectUser")
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _c("div", { staticClass: "selected-user" }, [
                        _c(
                          "div",
                          { staticClass: "user-info" },
                          [
                            _c(
                              "a-avatar",
                              {
                                staticStyle: { "margin-right": "12px" },
                                attrs: { size: 32 },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.getUserInitials(_vm.selectedUser)
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "user-details" }, [
                              _c("div", { staticClass: "user-name" }, [
                                _vm._v(_vm._s(_vm.selectedUser.name)),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "user-email" }, [
                                _vm._v(_vm._s(_vm.selectedUser.email)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "a-button",
                              {
                                staticStyle: { "margin-left": "auto" },
                                attrs: { type: "link", icon: "close" },
                                on: {
                                  click: function ($event) {
                                    _vm.selectedUser = null
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.$t("message.netgsmMappingRemove")
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: _vm.$t("message.netgsmMappingSelectUser"),
            footer: null,
            width: "800px",
            bodyStyle: { padding: "15px" },
          },
          model: {
            value: _vm.showUserPicker,
            callback: function ($$v) {
              _vm.showUserPicker = $$v
            },
            expression: "showUserPicker",
          },
        },
        [_c("UserPicker", { on: { "user-selected": _vm.onUserSelected } })],
        1
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: _vm.$t("message.netgsmMappingDeleteModalTitle"),
            confirmLoading: _vm.deleting,
          },
          on: {
            ok: _vm.confirmDeleteMapping,
            cancel: function ($event) {
              _vm.showDeleteModal = false
            },
          },
          model: {
            value: _vm.showDeleteModal,
            callback: function ($$v) {
              _vm.showDeleteModal = $$v
            },
            expression: "showDeleteModal",
          },
        },
        [
          _c("p", [
            _vm._v(_vm._s(_vm.$t("message.netgsmMappingDeleteConfirm"))),
          ]),
          _vm._v(" "),
          _vm.deletingMapping
            ? _c("div", { staticClass: "delete-info" }, [
                _c("strong", [_vm._v(_vm._s(_vm.deletingMapping.extension))]),
                _vm._v(" "),
                _c(
                  "i",
                  {
                    staticClass: "material-icons",
                    staticStyle: {
                      margin: "0 8px",
                      "vertical-align": "middle",
                    },
                  },
                  [_vm._v("arrow_forward")]
                ),
                _vm._v(" "),
                _c("strong", [
                  _vm._v(
                    _vm._s(_vm.$_.get(_vm.deletingMapping, "user.name", "-"))
                  ),
                ]),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("phone")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("link")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("link_off")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }